angular.module('app').factory('validationElementModifier', [
    "$timeout",
    function ($timeout)
    {
        var makeValid = function (el)
        {
            var scope = el.scope();
            if (scope.tooltip && scope.tooltip.hasOwnProperty(el.attr('name')))
            {
                scope.tooltip[el.attr('name')] = "";
                $timeout(function () {
                    scope.$apply();
                })
            }
        };

        var makeInvalid = function (el, errorMsg)
        {
            var scope = el.scope();
            if (scope.tooltip && scope.tooltip.hasOwnProperty(el.attr('name')) && el.attr('is-validate') !== 'false')
            {
                scope.tooltip[el.attr('name')] = errorMsg;

                $timeout(function ()
                {
                    scope.$apply();
                    if (errorMsg) {
                        el.triggerHandler('mouseenter');
                    }
                }, 0);
            }
            if(el.attr('is-validate') === 'false') {
                scope.tooltip[el.attr('name')] = "";
                $timeout(function () {
                    scope.$apply();
                });
            }
        };

        var makeDefault = function (el)
        {
            var scope = el.scope();
            if (scope.tooltip && scope.tooltip.hasOwnProperty(el.attr('name')))
            {
                scope.tooltip[el.attr('name')] = "";
                $timeout(function () {
                    scope.$apply();
                })
            }
        };

        return {
            makeValid: makeValid,
            makeInvalid: makeInvalid,
            makeDefault: makeDefault,
            key: 'validationModifierKey'
        };
    }
])